<template>
  <div>
    <h5>
      {{ i18n.t('/OrderInfoBlock/EmployeeInfo/BlockTitle') }}
      <button @click="showInfoModal = true">
        <icon icon="info-plain" large />
      </button>
    </h5>
    <address v-if="employee">
      {{ employee.EmployeeName }}<br />
      <span v-if="employee.EmployeePhone">{{ employee.EmployeePhone }} <br /></span>
      {{ employee.EmployeeEmail }}
    </address>

    <modal
      v-if="showInfoModal"
      :title="i18n.t('/OrderInfoBlock/EmployeeInfo/InfoModalTitle')"
      @close="showInfoModal = false"
    >
      <p>
        {{ i18n.t('/OrderInfoBlock/EmployeeInfo/InfoModalText') }}
      </p>
    </modal>
  </div>
</template>

<script>
import StoreConnector from '@/helpers/StoreConnector'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      employee: {},
      showInfoModal: false,
    }
  },
  mounted() {
    StoreConnector.get('quote/employee', (data) => {
      this.employee = data
    })
  },
}
</script>

<style></style>
